/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  ListPromoLinkBatchesOptions,
  ListPromoLinkBatchesResponses,
} from '../types/ListPromoLinkBatches'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Retrieve saved Campaign Links with campaign, link_type, affiliate selection, creation date and signups. Reusable entries omit allocation/issued/claimed/revoked counts. The same member can have many links/campaigns; separate link IDs preserve origin identity for future landing pages. Landing-page selection is out of scope. ADMIN, same-tenant INTEGRATOR, or AFFILIATE_MANAGER explicitly assigned to the owning QR campaign (including across tenants). Grants are checked on every request; tenant filters do not confer access.
 * @summary List promotional link batches
 * {@link /v1/trading_challenges/:trading_challenge_id/link_batches}
 */
export function listPromoLinkBatches<ThrowOnError extends boolean = true>(
  options: Options<ListPromoLinkBatchesOptions, ThrowOnError>,
): Unwrappable<RequestResult<ListPromoLinkBatchesResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/trading_challenges/{trading_challenge_id}/link_batches',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<ListPromoLinkBatchesResponses, ThrowOnError>>,
  )
}
